// Template Registry - All available templates
// Each template exports a renderer function and configuration schema

export const templates = [
  {
    id: 'logo_waveform_2d',
    name: 'Logo Waveform 2D',
    description: 'Horizontal waveform across center with logo at top',
    previewColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    defaultConfig: {
      primaryColor: '#667eea',
      secondaryColor: '#764ba2',
      backgroundColor: '#000000',
      logoScale: 1,
      sensitivity: 1,
      waveformHeight: 150,
    },
  },
  {
    id: 'circular_spectrum',
    name: 'Circular Spectrum',
    description: 'Circular frequency-based visualization around logo',
    previewColor: 'radial-gradient(circle, #667eea 0%, #000000 70%)',
    defaultConfig: {
      primaryColor: '#667eea',
      secondaryColor: '#764ba2',
      backgroundColor: '#000000',
      logoScale: 1,
      sensitivity: 1,
      radius: 200,
      barCount: 64,
    },
  },
  {
    id: 'horizontal_bars',
    name: 'Horizontal Bars',
    description: 'Classic audio bars under logo',
    previewColor: 'linear-gradient(180deg, #000000 0%, #667eea 100%)',
    defaultConfig: {
      primaryColor: '#667eea',
      secondaryColor: '#764ba2',
      backgroundColor: '#000000',
      logoScale: 1,
      sensitivity: 1,
      barCount: 32,
      barWidth: 10,
      barGap: 5,
    },
  },
  {
    id: 'neon_pulse',
    name: 'Neon Pulse',
    description: 'Pulsating neon rings with centered logo',
    previewColor: 'radial-gradient(circle, #ff006e 0%, #8338ec 50%, #000000 100%)',
    defaultConfig: {
      primaryColor: '#ff006e',
      secondaryColor: '#8338ec',
      accentColor: '#3a86ff',
      backgroundColor: '#0a0a0a',
      logoScale: 1,
      sensitivity: 1.2,
      ringCount: 5,
      maxRingSize: 400,
    },
  },
  {
    id: 'stereo_waves',
    name: 'Stereo Waves',
    description: 'Dual symmetrical waveforms with logo overlay',
    previewColor: 'linear-gradient(180deg, #00f5ff 0%, #000000 50%, #ff0080 100%)',
    defaultConfig: {
      primaryColor: '#00f5ff',
      secondaryColor: '#ff0080',
      backgroundColor: '#000000',
      logoScale: 1,
      sensitivity: 1.5,
      waveformHeight: 200,
      lineWidth: 3,
    },
  },
  {
    id: 'gradient_bars',
    name: 'Gradient Bars',
    description: 'Vertical bars with smooth rainbow gradient',
    previewColor: 'linear-gradient(90deg, #ff0080 0%, #ff8c00 25%, #40e0d0 50%, #4169e1 75%, #9400d3 100%)',
    defaultConfig: {
      backgroundColor: '#000000',
      logoScale: 1,
      sensitivity: 1.2,
      barCount: 64,
      barWidth: 15,
      barGap: 3,
      useRainbow: true,
    },
  },
  {
    id: 'modern_minimal',
    name: 'Modern Minimal',
    description: 'Clean minimalist design with subtle animation',
    previewColor: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
    defaultConfig: {
      primaryColor: '#2c3e50',
      secondaryColor: '#34495e',
      backgroundColor: '#ecf0f1',
      accentColor: '#3498db',
      logoScale: 1.2,
      sensitivity: 0.8,
      barCount: 40,
      showShadow: true,
    },
  },
  {
    id: 'retro_synthwave',
    name: 'Retro Synthwave',
    description: '80s inspired synthwave aesthetic',
    previewColor: 'linear-gradient(180deg, #ff006e 0%, #8338ec 50%, #3a86ff 100%)',
    defaultConfig: {
      primaryColor: '#ff006e',
      secondaryColor: '#8338ec',
      accentColor: '#3a86ff',
      backgroundColor: '#1a0033',
      gridColor: '#ff006e',
      logoScale: 1,
      sensitivity: 1.3,
      showGrid: true,
      perspectiveDepth: 300,
    },
  },
  {
    id: 'particle_burst',
    name: 'Particle Burst',
    description: 'Dynamic particle system reacting to audio',
    previewColor: 'radial-gradient(circle, #ffd700 0%, #ff4500 50%, #000000 100%)',
    defaultConfig: {
      primaryColor: '#ffd700',
      secondaryColor: '#ff4500',
      backgroundColor: '#000000',
      logoScale: 1,
      sensitivity: 1.5,
      particleCount: 100,
      particleSize: 3,
    },
  },
  {
    id: 'waveform_sphere',
    name: 'Waveform Sphere',
    description: '3D sphere effect with audio-reactive surface',
    previewColor: 'radial-gradient(circle, #00d9ff 0%, #0099cc 50%, #000033 100%)',
    defaultConfig: {
      primaryColor: '#00d9ff',
      secondaryColor: '#0099cc',
      backgroundColor: '#000033',
      logoScale: 1,
      sensitivity: 1.2,
      sphereRadius: 180,
      segments: 64,
    },
  },
];

// Get template by ID
export function getTemplateById(id) {
  return templates.find(t => t.id === id);
}
